import { Compass } from "lucide-react";
import { Link } from "react-router";

import { ROUTES } from "@/constants/routes";

/**
 * docs/ui/design-system.md §18: icon + heading + one clear action back,
 * never a bare "404" wall of text. docs/ui/routes.md notes a 404 should keep
 * the attempted route's chrome (`TopAppBar`/`Footer` or `BottomNav`) around
 * it — that wrapping happens once `MainAppLayout` exists; today this
 * renders standalone since it's reachable directly from the bootstrap's
 * catch-all route.
 */
export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <Compass className="h-12 w-12 text-muted-foreground" aria-hidden="true" />
      <div className="space-y-1">
        <h1 className="text-h1 text-foreground">Page not found</h1>
        <p className="max-w-sm text-body text-muted-foreground">
          The page you&rsquo;re looking for doesn&rsquo;t exist, or the link may be broken.
        </p>
      </div>
      <Link
        to={ROUTES.home}
        className="inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-button text-primary-foreground hover:bg-primary/90"
      >
        Back to Home
      </Link>
    </div>
  );
}
